exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-content{padding-top:20px}.page-content h1{position:relative;max-width:635px;padding-left:18px;padding-bottom:20px;font-size:16px;line-height:26px;color:#666}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Main.vue
 ** module id = 100
 ** module chunks = 0
 **/